import { useNavigate, useSimulatorMetadata } from 'hooks';
import { generateCampaignSimulatorPreviewPath } from 'modules/campaigns/services/utils';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useFetchedCampaign } from '../../modules/campaigns/hooks/useFetchedCampaign';
import { BID_STRATEGIES } from '../../modules/campaigns/modules/common-campaign-form/config/bidStrategies';
import { useSimulatorMonitor } from './hooks/useSimulatorMonitor';

export const useSimulatorButton = ({ campaignId, accountId, monitorId }) => {
    const navigate = useNavigate();
    const { trackSimulatorClick } = useSimulatorMonitor(monitorId);
    const { campaign } = useFetchedCampaign(campaignId, accountId);

    const isSimulatorButtonFFEnabled = useConfigMatch({
        [FEATURE_FLAGS.CAMPAIGN_SIMULATOR_BUTTON_ENABLED]: 'true',
    });

    const hasRequiredProps = !!campaignId && !!accountId;
    const isBiddingStrategySupported = campaign.bidStrategy === BID_STRATEGIES.MAX_CONVERSIONS;
    const isMetadataFetchEnabled = isSimulatorButtonFFEnabled && hasRequiredProps && isBiddingStrategySupported;

    const { data } = useSimulatorMetadata({
        campaignId,
        accountId,
        enabled: isMetadataFetchEnabled,
    });

    const eligible = data?.eligible ?? false;

    const handleClick = () => {
        trackSimulatorClick();

        const simulatorPath = generateCampaignSimulatorPreviewPath({
            accountId,
            campaignId,
        });
        navigate(simulatorPath);
    };

    return {
        shouldRender: eligible,
        handleClick,
    };
};
